import io from 'socket.io-client';
const CHAT = {
  socket: {},
  init: () => {
    //连接websocket后端服务器
    CHAT.socket = io(window.socket, { reconnect: true, withCredentials: true, path: process.env['BASE_PATH'] + '/connector/websocket/socket.io' })
  },
  //提交聊天消息内容
  submit: (data) => {
    if (data) {
      CHAT.socket.emit('message', data);
    } else {
      console.log('data is null')
    }
    return false;
  }
}
window.CHAT = CHAT;
export { CHAT }



// WEBPACK FOOTER //
// ./src/services/socket.js